import type { paths } from '@orlikfy/api-interfaces';

export { HostDto, TeamDto, TeamMemberCandidateDto, TeamMemberDto } from '@orlikfy/api-interfaces';

// GET /teams
export const GET_MY_TEAMS_PATH = '/teams' as const satisfies keyof paths;
type GetMyTeamsOperation = paths[typeof GET_MY_TEAMS_PATH]['get'];
export type GetMyTeamsResponse = GetMyTeamsOperation['responses'][200]['content']['application/json'];

// POST /teams
export const CREATE_TEAM_PATH = '/teams' as const satisfies keyof paths;
type CreateTeamOperation = paths[typeof CREATE_TEAM_PATH]['post'];
export type CreateTeamBody = CreateTeamOperation['requestBody']['content']['application/json'];
export type CreateResponse = CreateTeamOperation['responses'][200]['content']['application/json'];

// GET /teams/{teamId}
export const GET_TEAM_PATH = '/teams/{teamId}' as const satisfies keyof paths;
type GetTeamOperation = paths[typeof GET_TEAM_PATH]['get'];
export type GetTeamPathParams = GetTeamOperation['parameters']['path'];
export type GetTeamResponse = GetTeamOperation['responses'][200]['content']['application/json'];

// PATCH /teams/{teamId}
export const UPDATE_TEAM_PATH = '/teams/{teamId}' as const satisfies keyof paths;
type UpdateTeamOperation = paths[typeof UPDATE_TEAM_PATH]['patch'];
export type UpdateTeamPathParams = UpdateTeamOperation['parameters']['path'];
export type UpdateTeamBody = UpdateTeamOperation['requestBody']['content']['application/json'];
export type UpdateTeamResponse = UpdateTeamOperation['responses'][200]['content']['application/json'];

// DELETE /teams/{teamId}
export const DELETE_TEAM_PATH = '/teams/{teamId}' as const satisfies keyof paths;
type DeleteTeamOperation = paths[typeof DELETE_TEAM_PATH]['delete'];
export type DeleteTeamPathParams = DeleteTeamOperation['parameters']['path'];

// POST /teams/{teamId}/games
export const ASSIGN_GAMES_TO_TEAM_PATH = '/teams/{teamId}/games' as const satisfies keyof paths;
type AssignGamesToTeamOperation = paths[typeof ASSIGN_GAMES_TO_TEAM_PATH]['post'];
export type AssignGamesToTeamPathParams = AssignGamesToTeamOperation['parameters']['path'];
export type AssignGamesToTeamBody = AssignGamesToTeamOperation['requestBody']['content']['application/json'];
export type AssignGamesToTeamResponse = AssignGamesToTeamOperation['responses'][200]['content']['application/json'];

// GET /teams/{teamId}/members/candidates
export const GET_TEAM_MEMBER_CANDIDATES_PATH = '/teams/{teamId}/members/candidates' as const satisfies keyof paths;
type GetTeamMemberCandidatesOperation = paths[typeof GET_TEAM_MEMBER_CANDIDATES_PATH]['get'];
export type GetTeamMemberCandidatesPathParams = GetTeamMemberCandidatesOperation['parameters']['path'];
export type GetTeamMemberCandidatesResponse =
  GetTeamMemberCandidatesOperation['responses'][200]['content']['application/json'];

// POST /teams/{teamId}/members
export const ADD_TEAM_MEMBER_PATH = '/teams/{teamId}/members' as const satisfies keyof paths;
type AddTeamMemberOperation = paths[typeof ADD_TEAM_MEMBER_PATH]['post'];
export type AddTeamMemberPathParams = AddTeamMemberOperation['parameters']['path'];
export type AddTeamMemberBody = AddTeamMemberOperation['requestBody']['content']['application/json'];

// PATCH /teams/{teamId}/members/{userId}
export const UPDATE_TEAM_MEMBER_PATH = '/teams/{teamId}/members/{userId}' as const satisfies keyof paths;
type UpdateTeamMemberOperation = paths[typeof UPDATE_TEAM_MEMBER_PATH]['patch'];
export type UpdateTeamMemberPathParams = UpdateTeamMemberOperation['parameters']['path'];
export type UpdateTeamMemberBody = UpdateTeamMemberOperation['requestBody']['content']['application/json'];

// DELETE /teams/{teamId}/members/{userId}
export const REMOVE_TEAM_MEMBER_PATH = '/teams/{teamId}/members/{userId}' as const satisfies keyof paths;
type RemoveTeamMemberOperation = paths[typeof REMOVE_TEAM_MEMBER_PATH]['delete'];
export type RemoveTeamMemberPathParams = RemoveTeamMemberOperation['parameters']['path'];

// DELETE /teams/{teamId}/member/me
export const LEAVE_TEAM_PATH = '/teams/{teamId}/member/me' as const satisfies keyof paths;
type LeaveTeamOperation = paths[typeof LEAVE_TEAM_PATH]['delete'];
export type LeaveTeamPathParams = LeaveTeamOperation['parameters']['path'];

// POST /teams/{teamId}/invitations/accept
export const ACCEPT_TEAM_INVITATION_PATH = '/teams/{teamId}/invitations/accept' as const satisfies keyof paths;
type AcceptTeamInvitationOperation = paths[typeof ACCEPT_TEAM_INVITATION_PATH]['post'];
export type AcceptTeamInvitationPathParams = AcceptTeamInvitationOperation['parameters']['path'];
